'use strict';

var velocityPerSecond = require('../../../../../../motion-utils/dist/es/velocity-per-second.cjs');

const velocitySampleDuration = 5; // ms
function calcGeneratorVelocity(resolveValue, t, current) {
    const prevT = Math.max(t - velocitySampleDuration, 0);
    return velocityPerSecond.velocityPerSecond(current - resolveValue(prevT), t - prevT);
}

exports.calcGeneratorVelocity = calcGeneratorVelocity;
//# sourceMappingURL=velocity.cjs.map
